import * as React from 'react';
import classnames from 'classnames';

import Tooltip from 'components/Tooltip';
import InfluencerVerificationLabel from 'components/influencer-verification-label/InfluencerVerificationLabel';

import TileStandardContext from '../../../context/TileStandardContext';

import { __t, applyTranslations } from 'utils/language';
import { getIsBlockedStatus } from '../../../utils/tile-standard';

import './tile-standard-header-details-artist-name.scss';

applyTranslations(require('../../tile-standard-header.i18n.json'));

type Props = {
  artistName: string,
  url: string,
  isLightweight: boolean,
  shaded: boolean
};

const MSG_KEY = 'tile_standard_header';

const TileStandardHeaderDetailsArtistName = ({
  artistName,
  url,
  isLightweight,
  shaded
}: Props): JSX.Element => {
  const content = React.useContext(TileStandardContext);
  const blockUrl = getIsBlockedStatus(content?.isFreemium, content?.tileIndex);
  const updatedUrl = blockUrl ? '#' : url;

  const linkClasses = classnames('tile-standard-header-details-artist-name__link', 'text-overflow-ellipsis', {
    'tile-standard-header-details-artist-name__link--shaded': shaded
  });

  return (
    <div className="tile-standard-header-details-artist-name">
      <Tooltip
        message={__t(`${MSG_KEY}.tooltips.view_profile`)}
        width="auto-compact"
        display="flex"
      >
        <a
          href={updatedUrl}
          target="_blank"
          rel="noopener noreferrer"
          title={artistName}
          className={linkClasses}
        >
          {artistName}
        </a>
      </Tooltip>
      <div className="tile-standard-header-details-artist-name__verification-label">
        <InfluencerVerificationLabel
          type={isLightweight ? 'unverified' : 'verified'}
          withMargin
        />
      </div>
    </div>
  );
};

export default TileStandardHeaderDetailsArtistName;
